import responsiveAxis from './axis';
import responsivePointLabel from './label';
var preRenderResponsive = [];
var afterRenderResponsive = [
    { name: 'responsiveAxis', method: responsiveAxis },
    { name: 'responsivePointLabel', method: responsivePointLabel },
];
export default {
    preRender: preRenderResponsive,
    afterRender: afterRenderResponsive,
};
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_g2plot@1.1.24@@antv/g2plot/esm/plots/line/apply-responsive/index.js
// module id = null
// module chunks = 